import type { ForgeUIContentBylineItemExtensionType } from '../types.ts';

import { FORGE_MODULE_BYLINE } from '../ForgeModuleType.ts';
import { getLocalId } from './localId.ts';

type BylineExtension = Pick<ForgeUIContentBylineItemExtensionType, 'id' | 'properties'>;

export const getBylineAppContentPropertyKeys = (
	extensions: ReadonlyArray<BylineExtension> = (window.__SSR_FORGE_EXTENSIONS__?.[
		FORGE_MODULE_BYLINE
	]?.extensions as BylineExtension[] | undefined) ?? [],
): string[] => {
	const keys = new Set<string>();

	for (const extension of extensions) {
		const contentPropertyKey = extension.properties.contentPropertyKey;
		if (!contentPropertyKey) {
			continue;
		}

		// Forge UI Kit namespaces useContentProperty keys, while apps using the REST API can
		// persist the manifest key directly. Query both exact forms and keep the response bounded.
		keys.add(contentPropertyKey);
		keys.add(`forge-${getLocalId(extension.id)}-${contentPropertyKey}`);
	}

	return [...keys].sort();
};
